import styled from 'styled-components';
import { rem } from 'polished';
import TitleWidget from '../../core/TitleWidget';
import BoxInside from '../../core/BoxInside';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledBoxInside = styled(BoxInside)`
  padding-bottom: ${rem('80px')};
`;

const StyledTitleWidget = styled(TitleWidget)`
  line-height: ${rem('30px')};
  margin-bottom: ${rem('25px')};
  margin-left: ${rem('19px')};
  padding-left: ${rem('43px')};

  & > svg {
    left: ${rem('-17px')};
    top: ${rem('-3px')};
    bottom: inherit;

    bottom: 0;
    ${mediaqueries.greaterThan('desktop')`
      left: ${rem('-18px')};
      width: ${rem('48px')};
      height: ${rem('48px')};
      top: ${rem('-12px')};
    `};
  }
`;

export { StyledBoxInside, StyledTitleWidget };
